import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ARCHE_PATH } from '../constants';

const ADMIN_TABS = [
  { label: 'Tickets', path: `${ARCHE_PATH}/admin` },
  { label: 'FAQs', path: `${ARCHE_PATH}/admin/faqs` },
  { label: 'Knowledge Base', path: `${ARCHE_PATH}/admin/knowledge-base` },
  { label: 'Suggestions', path: `${ARCHE_PATH}/admin/suggestions` },
  { label: 'Bug Reports', path: `${ARCHE_PATH}/admin/bug-reports` },
] as const;

export function AdminNav() {
  const location = useLocation();

  const isActive = (tabPath: string) => {
    if (tabPath === `${ARCHE_PATH}/admin`) {
      // "Tickets" tab is active for /admin, /admin/tickets/...
      return (
        location.pathname === tabPath || location.pathname.startsWith(`${ARCHE_PATH}/admin/tickets`)
      );
    }
    return location.pathname.startsWith(tabPath);
  };

  return (
    <div className="border-b mb-6">
      <nav className="flex items-center gap-6 -mb-px">
        <Link
          to={ARCHE_PATH}
          className="py-2 px-1 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1.5 border-b-2 border-transparent"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Support Home
        </Link>
        {ADMIN_TABS.map((tab) => (
          <Link
            key={tab.path}
            to={tab.path}
            className={cn(
              'py-2 px-1 text-sm font-medium border-b-2 transition-colors',
              isActive(tab.path)
                ? 'border-primary text-primary'
                : 'border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground/50',
            )}
          >
            {tab.label}
          </Link>
        ))}
      </nav>
    </div>
  );
}
